module.exports = __webpack_public_path__ + "media/images/help/delivery/icon-point-2-e5fe259a1a8b2513c8406e98c7178f9d.svg";